import React, { useRef, useState } from 'react';
import Person from "../assets/icons/Person";
import Avatar from "../assets/icons/Avatar";
import PaintBrush from "../assets/icons/PaintBrush";
import Lock from "../assets/icons/Lock";
import SpecialLock from "../assets/icons/SpecialLock";
import { NavLink } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux"
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import CircleArrowDownward from "../assets/icons/CircleArrowDownward";
import "flatpickr/dist/themes/material_green.css";
import defaultPicture from '../assets/imgs/icon.png'
import {
    updateUserPasswordData, updateUserProfileData
} from "../store/profile/profileActions";
import { FileUrl } from "../components/utils/Urls";
import { profileActions } from "../store/profile/profileSlice";
import SettingsInput from "../components/textInput/SettingsInput";

function Settings(props) {
    const dispatch = useDispatch()
    const avatarImage = useSelector(state => state.image.avatarImage)
    const [editInputs, setEditInputs] = useState({ isNameHidden: true, isMiddleNameHidden: true, isSurnameHidden: true, isPhoneHidden: true, isBirthdayHidden: true, isTimeZoneHidden: true, isLanguageHidden: true, isPasswordHidden: true, isRePasswordHidden: true });
    const nameRef = useRef(null);
    const surnameRef = useRef(null);
    const middleNameRef = useRef(null);
    const phoneRef = useRef(null);
    const birthdayRef = useRef(null);
    const timezoneRef = useRef(null);
    const { userInfos, password } = useSelector(state => state.profile)
    const { identity, language } = useSelector(state => state.userInfos)
    const localInfos = useSelector(state => state.userInfos.userInfos)
    const [screen, setScreen] = useState('myInformation')
    const [showPassword, setShowPassword] = useState(true)

    const timeZones = ["(GMT-11:00) Midway Island, Samoa", "(GMT-10:00) Hawaii", "(GMT-9:00) Alaska", "(GMT-8:00) Dawson, Yukon", "(GMT-8:00) Tijuana", "(GMT-8:00) Pacific Time", "(GMT-7:00) Mountain Time", "(GMT-7:00) Chihuahua, La Paz, Mazatlan", "(GMT-7:00) Arizona", "(GMT-6:00) Central Time", "(GMT-6:00) Saskatchewan", "(GMT-6:00) Guadalajara, Mexico City, Monterrey", "(GMT-6:00) Central America", "(GMT-5:00) Eastern Time", "(GMT-5:00) Bogota, Lima, Quito", "(GMT-4:00) Caracas, La Paz", "(GMT-3:30) Newfoundland and Labrador", "(GMT-3:00) Santiago", "(GMT-3:00) Brasilia", "(GMT-3:00) Montevideo", "(GMT-3:00) Buenos Aires, Georgetown", "(GMT-3:00) Greenland", "(GMT-1:00) Azores", "(GMT-1:00) Cape Verde Islands", "(GMT+0:00) UTC", "(GMT+0:00) Edinburgh, London", "(GMT+0:00) Dublin", "(GMT+0:00) Lisbon", "(GMT+0:00) Casablanca, Monrovia", "(GMT+0:00) Canary Islands", "(GMT+1:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", "(GMT+1:00) Sarajevo, Skopje, Warsaw, Zagreb", "(GMT+1:00) Brussels, Copenhagen, Madrid, Paris", "(GMT+1:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", "(GMT+1:00) West Central Africa", "(GMT+2:00) Bucharest", "(GMT+2:00) Cairo", "(GMT+2:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius", "(GMT+2:00) Athens, Istanbul, Minsk", "(GMT+2:00) Jerusalem", "(GMT+2:00) Harare, Pretoria", "(GMT+3:00) Moscow, St. Petersburg, Volgograd", "(GMT+3:00) Kuwait, Riyadh", "(GMT+3:00) Nairobi", "(GMT+3:00) Baghdad", "(GMT+3:30) Tehran", "(GMT+4:00) Abu Dhabi, Muscat", "(GMT+4:30) Kabul", "(GMT+5:00) Baku, Tbilisi, Yerevan", "(GMT+5:00) Ekaterinburg", "(GMT+5:00) Islamabad, Karachi, Tashkent", "(GMT+5:30) Chennai, Kolkata, Mumbai, New Delhi", "(GMT+5:30) Sri Jayawardenepura", "(GMT+5:45) Kathmandu", "(GMT+6:00) Astana, Dhaka", "(GMT+6:00) Almaty, Novosibirsk", "(GMT+6:30) Yangon Rangoon", "(GMT+7:00) Bangkok, Hanoi, Jakarta", "(GMT+7:00) Krasnoyarsk", "(GMT+8:00) Beijing, Chongqing, Hong Kong SAR, Urumqi", "(GMT+8:00) Kuala Lumpur, Singapore", "(GMT+8:00) Taipei", "(GMT+8:00) Perth", "(GMT+8:00) Irkutsk, Ulaanbaatar", "(GMT+9:00) Seoul", "(GMT+9:00) Osaka, Sapporo, Tokyo", "(GMT+9:30) Darwin", "(GMT+10:00) Yakutsk", "(GMT+10:00) Brisbane", "(GMT+10:00) Vladivostok", "(GMT+10:00) Guam, Port Moresby", "(GMT+10:30) Adelaide", "(GMT+11:00) Canberra, Melbourne, Sydney", "(GMT+11:00) Hobart", "(GMT+11:00) Magadan, Solomon Islands, New Caledonia", "(GMT+12:00) Kamchatka, Marshall Islands", "(GMT+13:00) Fiji Islands", "(GMT+13:00) Auckland, Wellington", "(GMT+14:00) Nuku'alofa"]

    function saveSettings() {
        dispatch(updateUserProfileData(localInfos.id, userInfos))
    }

    function savePassword() {
        dispatch(updateUserPasswordData(password.password, localInfos.id))
    }

    // useEffect(()=>{
    //     if(identity === 'student'){
    //         dispatch(fetchStudentData(localInfos.id))
    //     }
    //     else if(identity === 'parent'){
    //         dispatch(fetchParentData(localInfos.id))
    //     }
    //     else{
    //         //teacher
    //     }
    // },[dispatch])

    return (
        <div className="container px-3 mx-auto max-w-screen-lg mt-5">
            <div className="flex flex-col md:flex-row bg-white px-8 py-5 gap-8">
                <div className="flex flex-col w-full md:w-3/12">
                    <div className="border border-gray-300 h-52 flex items-center justify-center">
                        <img className={`max-h-full p-3 ${!avatarImage.length ? 'invert' : ''}`} src={avatarImage.length > 4 ? FileUrl + avatarImage : defaultPicture} alt="" />
                    </div>
                    <h2 className="text-center mt-3">{userInfos.firstName} {userInfos.lastName}</h2>
                    <span className="text-center text-sm text-gray-400">{userInfos.mail}</span>
                    <div onClick={() => setScreen("myInformation")} className={`flex items-center w-full cursor-pointer rounded-md px-4 py-2 mt-3 ${screen === "myInformation" ? "bg-primary text-white" : "bg-gray-100 text-black"}`}>
                        <Person fill={"currentColor"} />
                        <span className="mx-2">{language.my_information}</span>
                    </div>
                    {
                        identity === 'student' &&
                        <div className="flex flex-col">
                            <NavLink to="/user/settings/avatar-builder" className="flex items-center w-full bg-gray-100 text-black rounded-md px-4 py-2 mt-2">
                                <Avatar fill={"#1b3638"} />
                                <span className="mx-2">{language.avatar_builder}</span>
                            </NavLink>
                            <NavLink to="/user/settings/background-builder" className="flex items-center w-full bg-gray-100 text-black rounded-md px-4 py-2 mt-2">
                                <PaintBrush fill={"#1b3638"} />
                                <span className="mx-2">{language.background_builder}</span>
                            </NavLink>
                        </div>
                    }
                    <div onClick={() => setScreen("passwordChange")} className={`flex items-center w-full cursor-pointer rounded-md px-4 py-2 mt-3 ${screen === "passwordChange" ? "bg-primary text-white" : "bg-gray-100 text-black"}`}>
                        <Lock />
                        <span className="mx-2">{language.password_change}</span>
                    </div>
                </div>
                {
                    screen === "myInformation" ?
                        <div className="flex flex-col w-full md:w-9/12">
                            <h1>{language.my_profile}</h1>
                            <div className="flex justify-between items-center px-5 mt-4 py-1 border border-gray-200">
                                <div className="flex flex-col">
                                    <span className="text-gray-300 text-sm">{language.user_id}</span>
                                    <input className="text-bold bg-transparent text-sm" value={userInfos.id} type="text" disabled />
                                </div>
                                <SpecialLock />
                            </div>
                            <div className="flex justify-between items-center px-5 mt-2 py-1 border border-gray-200">
                                <div className="flex flex-col w-full">
                                    <span className="text-gray-300 text-sm">{language.e_mail}</span>
                                    <input className="text-bold bg-transparent w-full text-sm" value={userInfos.mail} type="text" disabled />
                                </div>
                                <SpecialLock />
                            </div>
                            <SettingsInput
                                label={language.first_name}
                                onChange={(e) => dispatch(profileActions.updateUserInfos({ firstName: e.target.value }))}
                                value={userInfos.firstName}
                                editText={language.edit}
                                type="text"
                            />
                            <SettingsInput
                                label={language.middle_name}
                                onChange={(e) => dispatch(profileActions.updateUserInfos({ middleName: e.target.value }))}
                                value={userInfos.middleName}
                                editText={language.edit}
                                type="text"
                            />
                            <SettingsInput
                                label={language.last_name}
                                onChange={(e) => dispatch(profileActions.updateUserInfos({ lastName: e.target.value }))}
                                value={userInfos.lastName}
                                editText={language.edit}
                                type="text"
                            />
                            <div className="flex justify-between items-center px-5 mt-2 py-1 border border-gray-200">
                                <div className="flex flex-col w-9/12">
                                    <span className="text-gray-300 text-sm">{language.phone}</span>
                                    <div className={`flex items-center ${editInputs.isPhoneHidden ? 'opacity-40' : 'opacity-100'}`}>
                                        <PhoneInput
                                            inputStyle={{ border: 'none', height: 20, paddingRight: 40 }}
                                            buttonStyle={{ border: 'none', background: 'none', paddingRight: 20 }}
                                            disabled={!!editInputs.isPhoneHidden}
                                            country={'us'}
                                            value={userInfos.phone}
                                            innerRef={phoneRef}
                                            {...props}
                                            onBlur={() => setEditInputs({ ...editInputs, isPhoneHidden: true })}
                                            onChange={phone => {
                                                dispatch(profileActions.updateUserInfos({ phone: phone }))
                                            }}
                                        />
                                    </div>
                                </div>
                                <div onClick={() => {
                                    setEditInputs({ ...editInputs, isPhoneHidden: false })
                                    // setTimeout(()=>{
                                    //     phoneRef.current.focus()
                                    // },100)
                                }} className="cursor-pointer">{language.edit}</div>
                            </div>
                            <div className="flex justify-between items-center px-5 mt-2 py-1 border border-gray-200">
                                <div className={`flex flex-col w-9/12 ${editInputs.isBirthdayHidden ? 'opacity-40' : 'opacity-100'}`}>
                                    <span className="text-gray-300 text-sm">{language.birthday}</span>
                                    <input
                                        className="outline-none focus:outline-none focus:ring focus:ring-gray-300 p-1 cursor-pointer"
                                        onBlur={() => setEditInputs({ ...editInputs, isBirthdayHidden: true })}
                                        disabled={!!editInputs.isBirthdayHidden}
                                        ref={birthdayRef}
                                        value={userInfos.birthdate}
                                        onChange={(e) =>
                                            dispatch(profileActions.updateUserInfos({ birthdate: e.target.value }))
                                        }
                                        type="date"
                                    />
                                </div>
                                <div onClick={() => {
                                    setEditInputs({ ...editInputs, isBirthdayHidden: false })
                                }} className="cursor-pointer">{language.edit}</div>
                            </div>
                            <div className="flex justify-between items-center px-5 mt-2 py-1 border border-gray-200">
                                <div className={`flex flex-col ${editInputs.isTimeZoneHidden ? 'opacity-40' : 'opacity-100'}`}>
                                    <span className="text-gray-300 text-sm">{language.time_zone}</span>
                                    <div className="flex relative items-center">
                                        <select
                                            value={userInfos.timeZone}
                                            disabled={!!editInputs.isTimeZoneHidden}
                                            onBlur={() => setEditInputs({ ...editInputs, isTimeZoneHidden: true })}
                                            ref={timezoneRef}
                                            onChange={(e) => {
                                                dispatch(profileActions.updateUserInfos({ timeZone: e.target.value }))
                                            }}
                                            className="text-gray-400 appearance-none text-sm rounded-md bg-gray-100 outline-none py-2 pl-2 pr-8" type="text"
                                        >
                                            <option value="">{language.choose}</option>
                                            {
                                                timeZones.map((item) => {
                                                    return (
                                                        <option value={item}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <CircleArrowDownward />
                                    </div>
                                </div>
                                <div onClick={() => {
                                    setEditInputs({ ...editInputs, isTimeZoneHidden: false })
                                }} className="cursor-pointer">{language.edit}</div>
                            </div>
                            <div className="mt-5 mb-2 py-3 sm:flex sm:flex-row-reverse">
                                <div className="mt-5 mb-2 py-3 sm:flex sm:flex-row-reverse">
                                    <button onClick={saveSettings} type="button"
                                        className={`${props.language === "English" || props.language === "Deutsch" || props.language === "Türkçe" ? "sm:ml-3" : "sm:mr-3"} mt-3 w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-primary text-base font-medium text-white focus:outline-none sm:mt-0 sm:w-auto sm:text-sm`}>
                                        {language.save}
                                    </button>
                                    <button type="button" className={`${props.language === "English" || props.language === "Deutsch" || props.language === "Türkçe" ? "sm:ml-3" : "sm:mr-3"} mt-3 sm:mt-0 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-dark-primary text-base font-medium text-white focus:outline-none sm:w-auto sm:text-sm`}>
                                        {language.cancel}
                                    </button>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="flex flex-col w-full md:w-9/12">
                            <div className="flex justify-between items-center px-5 mt-2 py-2 border border-gray-200">
                                <div className={`flex flex-col w-6/12 flex-1'}`}>
                                    <input placeholder={language.password}
                                        onChange={(e) =>
                                            dispatch(profileActions.updateUserInfos({ password: e.target.value }))
                                        }
                                        ref={middleNameRef} className="text-bold bg-transparent text-sm outline-none" type={`${showPassword ? "password" : "text"}`} />
                                </div>
                                <div onClick={() => {
                                    setShowPassword(!showPassword)
                                }} className="cursor-pointer">{showPassword ? language.show : language.hide}</div>
                            </div>
                            <div className="flex justify-between items-center px-5 mt-2 py-2 border border-gray-200">
                                <div className={`flex flex-col w-6/12 flex-1'}`}>
                                    <input placeholder={language.re_password}
                                        onChange={(e) =>
                                            dispatch(profileActions.updateUserInfos({ rePassword: e.target.value }))
                                        }
                                        className="text-bold w-full bg-transparent text-sm outline-none" type={`${showPassword ? "password" : "text"}`} />
                                </div>
                                <div onClick={() => {
                                    setShowPassword(!showPassword)
                                }} className="cursor-pointer">{showPassword ? language.show : language.hide}</div>
                            </div>
                            <div className="mt-5 mb-2 py-3 sm:flex sm:flex-row-reverse">
                                <button onClick={savePassword} type="button"
                                    className={`${props.language === "English" || props.language === "Deutsch" || props.language === "Türkçe" ? "sm:ml-3" : "sm:mr-3"} mt-3 w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-primary text-base font-medium text-white focus:outline-none sm:mt-0 sm:w-auto sm:text-sm`}>
                                    {language.save}
                                </button>
                                <button type="button" className={`${props.language === "English" || props.language === "Deutsch" || props.language === "Türkçe" ? "sm:ml-3" : "sm:mr-3"} w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-dark-primary text-base font-medium text-white focus:outline-none sm:w-auto sm:text-sm`}>
                                    {language.cancel}
                                </button>
                            </div>
                        </div>
                }
            </div>
        </div>
    );
}

// export default Settings;

export default Settings;